import { Button } from "antd";
import PropTypes from "prop-types";
import saveScheduleIcon from "../../../app/assets/images/Save.png";
import cancelScheduleIcon from "../../../app/assets/images/CancelSchedule.png";

const SaveSchedule = ({ onCancel, onSaveSuccess, onDiscard, isSave, isLoading }) => {
  return (
    <div className="flex flex-col align-middle items-center py-12 px-4">
      <img src={isSave ? saveScheduleIcon : cancelScheduleIcon} alt="Status Icon" className="h-24 w-auto mb-4" />

      <div className="text-center">
        <h2 className="font-semibold m-0 p-0 text-2xl">{isSave ? "Save Schedule?" : "Cancel Schedule?"}</h2>
        <p className="p-0 m-0 text-gray-500">{isSave ? "Your schedule updates will be saved." : "Your updates to the schedule won't be saved."}</p>
      </div>

      <div className="flex justify-center gap-6 mt-12 w-full">
        <Button size="large" className="w-40 !border-orange-500 !text-orange-500 hover:opacity-70 font-semibold rounded-lg" onClick={onCancel}>
          {isSave ? "CANCEL" : "RETURN"}
        </Button>

        <Button
          type="primary"
          size="large"
          loading={isLoading}
          className="w-40 border-none font-semibold rounded-lg hover:opacity-80"
          style={{ backgroundColor: "#F45F0C" }}
          onClick={isSave ? onSaveSuccess : onDiscard}
        >
          {isSave ? "SAVE" : "DISCARD"}
        </Button>
      </div>
    </div>
  );
};

SaveSchedule.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onSaveSuccess: PropTypes.func.isRequired,
  onDiscard: PropTypes.func.isRequired,
  isSave: PropTypes.bool,
  isLoading: PropTypes.bool,
};

export default SaveSchedule;
